<div class="loading-overlay" [attr.aria-busy]="loading">
  <div class="loading-overlay__content" [attr.inert]="loading ? '' : null">
    <ng-content></ng-content>
  </div>
  @if (loading) {
    <div class="loading-overlay__veil">
      <app-loading-spinner class="loading-overlay__spinner"></app-loading-spinner>
    </div>
  }
</div>
